import { useEffect, useState } from "react";
import Update from "../../table/Update";
import ApiService from "../../../services/apiService";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { emailTitle,updateEmails } from "../../../constants";
import { useNavigate } from "react-router-dom";
const UpdateEmail = () => {
    const [emailData,setEmailData] = useState<any>({});
    const [name,setName] = useState<string>("");
    const {Id} = useParams();
    const navigate = useNavigate();

    const initalData ={
        Email:emailData?.email,
        Name:emailData?.name
    }

    useEffect(()=>{

         const fetchEmail = async ()=>{
            try{
            const response = await ApiService.axiosApi(`/email/${Id}`,{
                method : 'GET'
            });
            if(response.success){
              console.log(response.data || "Email Fetched Successfully");
              setEmailData(response.data);
            }else{
                console.log(response.message || "Unable to fetch Email");
            }
        }catch(error:any){
            console.log(error.message || "Unable to fetch Email");
        }
         }
         fetchEmail();
    },[])

    const updateEmail = async (data:any)=>{
        try{
            const response = await ApiService.axiosApi(`/email/${Id}`,{
                method : 'PUT',
                data : data
            })
            if(response.success){
                toast.success(response.message || "Email Updated Successfully");
                navigate(-1)
            }else{
                toast.error(response.message || "Unable to update Email");
            }
        }catch(error:any){
            toast.error(error.message || "Unable to update Email");
        }
    }

    return(
        <Update
        title={updateEmails}
        parentTitle = {emailTitle}
        fields={[
            {
                name : "Email",
                label : "Email",
                type : "email",
                validation : {required : "Email is required"}
            },
            {   
                name : "Name",
                label : "Name",
                type : "text",
                validation : {required : "Name is required"}
            }
        ]}
        onSubmit={updateEmail}
        initialData={initalData}

    />
    )
}

export default UpdateEmail;
